import { PropsWithChildren } from 'react';

import { BoxProps } from '@chakra-ui/react';

import { Card } from '~/components/card';

export function PlanPriceCardLayout({ children, ...rest }: PropsWithChildren<BoxProps>) {
  return (
    <Card
      as='article'
      backdropFilter='blur(8px)'
      bgColor='accent.sky.100'
      border='1px solid'
      borderRadius='lg'
      display='flex'
      flex='1'
      flexDir='column'
      padding='24px'
      position='relative'
      {...rest}
    >
      {children}
    </Card>
  );
}
